/** @format */

import { safeStorage } from "@/utils/storage";

const VISIT_COUNT_KEY = "galaxie-visit-count";
const LEGACY_VISIT_COUNT_KEY = "pwa-install-visits";

/**
 * Get the current visit count, migrating from the legacy PWA key if needed.
 */
export function getVisitCount(): number {
  const count = safeStorage.getItem(VISIT_COUNT_KEY);
  if (count !== null) return Number(count);

  // Migration: check legacy PWA key
  const legacyCount = safeStorage.getItem(LEGACY_VISIT_COUNT_KEY);
  if (legacyCount !== null) {
    safeStorage.setItem(VISIT_COUNT_KEY, legacyCount);
    return Number(legacyCount);
  }

  return 0;
}

/**
 * Increment the visit count and return the new value.
 * Should be called once per page load (in usePWAInstallPrompt).
 */
export function incrementVisitCount(): number {
  const count = getVisitCount() + 1;
  safeStorage.setItem(VISIT_COUNT_KEY, String(count));
  return count;
}
